import {
    Box,
    Button,
    Flex,
    Heading,
    Image,
    Link as LinkStyle,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useDisclosure
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, Redirect, useHistory } from "react-router-dom";
import { LanguagePicker } from "../../components/LanguagePicker";
import { CreateDoctorRequestForm } from "../../forms/CreateDoctorRequestForm";
import { LanguageCode, useCreateDoctorRequestMutation } from "../../graphql";

import AuthPage from "../../layouts/Authentication";

const RegisterDoctorPage: React.FC = ({ children }) => {
    const { t } = useTranslation();
    const history = useHistory();

    const { isOpen, onOpen, onClose } = useDisclosure();

    const [
        createDoctorRequest,
        { data, loading }
    ] = useCreateDoctorRequestMutation();

    const handleSubmit = async (event) => {
        event.preventDefault();
    };

    return (
        <AuthPage>
            <Modal onClose={ onClose } isOpen={ isOpen } isCentered>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>{ t("registerDoctor.okRegister") }</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>{ t("registerDoctor.okContact") }</ModalBody>
                    <ModalFooter>
                        <Button
                            onClick={ () => {
                                history.push("/login");
                            } }
                            variant="primary"
                        >
                            { t("registerDoctor.ok") }
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            <Flex width="full" align="center" justifyContent="center" marginTop={ 20 }>
                <Box
                    p={ 5 }
                    background="white"
                    borderWidth={ 1 }
                    borderRadius={ 8 }
                    boxShadow="lg"
                    w={ [300, 300, 400, 430, 430] }
                >
                    <Box textAlign="center">
                        <Image src="/logo-white.png" />

                        <Heading>{ t("login.register") } </Heading>
                        <p>{ t("registerDoctor.apply") } </p>
                        <p>
                            { t("login.haveAccount") }{ " " }
                            <LinkStyle>
                                <Link to="/login">{ t("login.login") }</Link>
                            </LinkStyle>
                        </p>
                    </Box>
                    <Box my={ 4 } textAlign="left">
                        <CreateDoctorRequestForm
                            onSubmit={ async (data) => {
                                const { data: doctorRequest } = await createDoctorRequest({
                                    variables: {
                                        birthday: data.birthday,
                                        cityId: parseInt(data.cityId),
                                        countryId: parseInt(data.countryId),
                                        cvKey: data.cv.key,
                                        email: data.email,
                                        healthCenterId: parseInt(data.healthCenterId),
                                        languageCode: LanguageCode.Sq,
                                        lastname: data.lastname,
                                        licenceNumber: data.licenceNumber,
                                        name: data.name,
                                        password: data.password,
                                        phoneNumber: data.phoneNumber,
                                        sex: data.sex
                                    }
                                });

                                onOpen();
                            } }
                        />
                    </Box>
                    <LanguagePicker />
                </Box>
            </Flex>
        </AuthPage>
    );
};

export default RegisterDoctorPage;
